// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes HeroV4_heroContentReveal__cUbIX {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* The banner crossfade deliberately has no keyframes: it is written frame by
   frame from Hero.js (see useHeroBannerCrossfade). A CSS animation here would
   be suppressed by prefers-reduced-motion on the devices this has to work on. */

@keyframes HeroV4_heroGlowDrift__77qDm {
  0%,
  100% {
    opacity: 0.58;
    transform: translate3d(0, 0, 0) scale(1);
  }
  50% {
    opacity: 0.82;
    transform: translate3d(-18px, 10px, 0) scale(1.06);
  }
}

.HeroV4_hero__YXyJQ {
  position: relative;
  /* vh first: browsers without dvh (iOS Safari < 15.4) drop the second line
     and keep a working height instead of collapsing the banner. */
  min-height: clamp(660px, calc(100vh - 120px), 840px);
  min-height: clamp(660px, calc(100dvh - 120px), 840px);
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
  box-sizing: border-box;
  background: #edf4ff;
}

/* Wrapper carries the shared visual treatment so the crossfading images
   themselves only ever animate \`opacity\`. Longhand offsets instead of \`inset\`
   for Safari < 14.1. */
.HeroV4_heroBackdropStack__7MhA1 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  filter: saturate(1.03) contrast(1.01);
  transform: scale(1.015);
}

.HeroV4_heroBackdrop__lIUWG {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center right;
  /* Read by the object-fit-images polyfill; harmless everywhere else. */
  font-family: 'object-fit: cover; object-position: center right;';
  backface-visibility: hidden;
}

/* Second banner sits on top and fades in/out over the first one. Hero.js owns
   the opacity from requestAnimationFrame once both banners have decoded, so a
   slow or failed download can never crossfade to a blank layer, and no browser
   motion setting can stop the fade. 0 here is the resting/fallback state. */
.HeroV4_heroBackdropAlt__3LQOy {
  opacity: 0;
  will-change: opacity;
  /* A global \`transition: all\` rule is in scope here; left alone it re-times
     every frame we write. The rAF timeline is the only thing driving this. */
  transition: none;
}

.HeroV4_heroOverlay__rBz5F {
  position: absolute;
  z-index: 1;
  /* Longhand offsets instead of \`inset\` for Safari < 14.1, which would
     otherwise drop the shorthand and leave the scrim unpositioned. */
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background:
    radial-gradient(
      circle at 12% 17%,
      rgba(255, 255, 255, 0.96) 0,
      rgba(255, 255, 255, 0) 31%
    ),
    linear-gradient(
      90deg,
      #f8faff 0%,
      rgba(248, 250, 255, 0.98) 24%,
      rgba(248, 250, 255, 0.88) 42%,
      rgba(238, 245, 255, 0.36) 65%,
      rgba(222, 235, 255, 0.05) 100%
    );
  pointer-events: none;
}

.HeroV4_heroGlow__KNEsb {
  position: absolute;
  z-index: 2;
  top: 12%;
  left: 34%;
  width: 330px;
  height: 330px;
  border-radius: 50%;
  background: rgba(54, 135, 255, 0.18);
  filter: blur(90px);
  animation: HeroV4_heroGlowDrift__77qDm 9s ease-in-out infinite;
  pointer-events: none;
}

.HeroV4_heroContent__jbBbz {
  position: relative;
  z-index: 15;
  width: 100%;
  max-width: 1344px;
  margin: 0 auto;
  padding: clamp(64px, 8vh, 92px) 32px 120px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.HeroV4_heroInner__MRZbh {
  width: min(100%, 660px);
  animation: HeroV4_heroContentReveal__cUbIX 600ms ease-out both;
}

.HeroV4_heroEyebrow__MTsnn {
  width: fit-content;
  min-height: 32px;
  margin-bottom: 20px;
  padding: 6px 11px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(10, 100, 249, 0.2);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 7px 22px rgba(32, 83, 150, 0.08);
  color: #075bd7;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.09em;
  line-height: 18px;
  text-transform: uppercase;
  backdrop-filter: blur(12px);
}

.HeroV4_heroTitle__xOrTh {
  max-width: 650px;
  margin: 0;
  color: #071b35;
  font-size: clamp(48px, 5.05vw, 72px);
  font-weight: 880;
  letter-spacing: -0.058em;
  line-height: 0.99;
  text-wrap: balance;
}

.HeroV4_heroTitleHighlight__xHXks {
  display: inline;
  background: linear-gradient(110deg, #075ee8 4%, #0a74ff 56%, #0957d7 100%);
  background-clip: text;
  color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.HeroV4_heroSubtitle__8J4fr {
  max-width: 570px;
  margin: 22px 0 28px;
  color: #52647c;
  font-size: clamp(16px, 1.3vw, 18px);
  font-weight: 560;
  line-height: 1.65;
  text-wrap: pretty;
}

.HeroV4_searchBox__hRgat {
  position: relative;
  z-index: 2;
  width: min(100%, 650px);
  margin: 0;
  padding: 12px;
  border: 1px solid rgba(194, 211, 234, 0.86);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow:
    0 24px 70px rgba(21, 61, 119, 0.15),
    0 3px 10px rgba(21, 61, 119, 0.05);
  box-sizing: border-box;
  backdrop-filter: blur(18px);
}

.HeroV4_searchBoxHeader__7Khi4 {
  min-height: 29px;
  padding: 0 5px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.HeroV4_searchLabel__wdmLP {
  color: #182f4e;
  font-size: 12px;
  font-weight: 820;
  letter-spacing: -0.01em;
  line-height: 18px;
}

.HeroV4_searchCoverage__6MbOd {
  color: #74849a;
  font-size: 10px;
  font-weight: 720;
  letter-spacing: 0.04em;
  line-height: 16px;
  text-transform: uppercase;
  white-space: nowrap;
}

.HeroV4_searchInputWrapper__J9eu1 {
  display: flex;
  align-items: stretch;
  gap: 9px;
}

.HeroV4_inputWrap__GsJ2D {
  position: relative;
  min-width: 0;
  flex: 1 1 auto;
}

.HeroV4_inputIcon__rszDu {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 17px;
  color: #0a64f9;
  transform: translateY(-50%);
  pointer-events: none;
}

.HeroV4_searchInput__kq7kh {
  width: 100%;
  min-height: 58px;
  padding: 0 44px 0 49px;
  border: 1px solid #dde8f6;
  border-radius: 13px;
  outline: none;
  background: #f3f7fd;
  color: #102741;
  font-family: 'Manrope', 'Inter', system-ui, sans-serif;
  font-size: 15px;
  font-weight: 620;
  box-sizing: border-box;
  transition:
    border-color 160ms ease,
    background 160ms ease,
    box-shadow 160ms ease;
}

.HeroV4_searchInput__kq7kh::placeholder {
  color: #7d899a;
  font-weight: 520;
}

.HeroV4_searchInput__kq7kh:hover {
  border-color: #c6d8ee;
  background: #f8fbff;
}

.HeroV4_searchInput__kq7kh:focus {
  border-color: #6da5f8;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(10, 100, 249, 0.11);
}

.HeroV4_loader__aSiAm {
  position: absolute;
  top: 50%;
  right: 15px;
  display: grid;
  place-items: center;
  color: #0a64f9;
  transform: translateY(-50%);
}

.HeroV4_searchBtn__7btV2 {
  min-width: 170px;
  min-height: 58px;
  padding: 0 23px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  flex: 0 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 13px;
  background: linear-gradient(135deg, #0b6bff 0%, #084ecf 100%);
  box-shadow: 0 11px 24px rgba(8, 82, 207, 0.24);
  color: #fff;
  font-family: 'Manrope', 'Inter', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 820;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  transition:
    box-shadow 160ms ease,
    transform 160ms ease,
    filter 160ms ease;
}

.HeroV4_searchBtn__7btV2:hover:not(:disabled) {
  filter: brightness(1.06);
  box-shadow: 0 14px 30px rgba(8, 82, 207, 0.32);
  transform: translateY(-1px);
}

.HeroV4_searchBtn__7btV2:active:not(:disabled) {
  transform: translateY(0);
}

.HeroV4_searchBtn__7btV2:disabled {
  opacity: 0.68;
  cursor: wait;
}

.HeroV4_searchBtn__7btV2:focus-visible,
.HeroV4_signInLink__LLQ2\\+:focus-visible {
  outline: 3px solid rgba(10, 100, 249, 0.24);
  outline-offset: 3px;
}

.HeroV4_dropdown__BTdEQ {
  position: absolute;
  z-index: 20;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  width: 100%;
  max-height: min(260px, calc(100vh - 90px));
  max-height: min(260px, calc(100dvh - 90px));
  margin: 0;
  padding: 6px;
  overflow: hidden auto;
  border: 1px solid #dce7f4;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 22px 52px rgba(13, 40, 77, 0.2);
  list-style: none;
  backdrop-filter: blur(16px);
}

.HeroV4_dropdownItem__tWDSK {
  min-height: 54px;
  padding: 9px 10px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border-radius: 10px;
  color: #34465e;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition:
    background 140ms ease,
    color 140ms ease;
}

.HeroV4_dropdownItem__tWDSK:hover,
.HeroV4_dropdownItemActive__QKtqz,
.HeroV4_dropdownItem__tWDSK[aria-selected='true'] {
  background: #edf5ff;
  color: #0a55c7;
}

.HeroV4_dropdownItemIconWrapper__3kdgJ {
  width: 30px;
  height: 30px;
  margin-top: 1px;
  display: grid;
  place-items: center;
  flex: 0 0 30px;
  border-radius: 9px;
  background: #e5f0ff;
  color: #0a64f9;
}

.HeroV4_dropdownItemText__qRdg7 {
  min-width: 0;
  padding-top: 1px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.HeroV4_dropdownItemPrimary__DW8Qn,
.HeroV4_dropdownItemSecondary__lko4R {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.HeroV4_dropdownItemPrimary__DW8Qn {
  color: #112841;
  font-size: 13px;
  font-weight: 760;
  line-height: 18px;
}

.HeroV4_dropdownItemSecondary__lko4R {
  color: #6d7d91;
  font-size: 11px;
  font-weight: 540;
  line-height: 16px;
}

.HeroV4_error__g1aoX {
  margin: 9px 4px 0;
  padding: 8px 10px;
  border: 1px solid #ffd3d8;
  border-radius: 9px;
  background: #fff5f6;
  color: #b42335;
  font-size: 11px;
  font-weight: 690;
  line-height: 16px;
  text-align: left;
}

.HeroV4_heroActions__ukvXG {
  min-height: 32px;
  margin-top: 10px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.HeroV4_signInText__P2Ewl {
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #65748a;
  font-size: 11px;
  font-weight: 640;
  line-height: 17px;
}

.HeroV4_signInLink__LLQ2\\+ {
  margin: 0 -2px 0 1px;
  padding: 3px 2px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #075bdb;
  font: inherit;
  font-weight: 820;
  cursor: pointer;
}

.HeroV4_signInLink__LLQ2\\+:hover {
  color: #0647aa;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.HeroV4_heroAssurances__NYc1s {
  margin-top: 15px;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  gap: 8px;
}

.HeroV4_heroAssurances__NYc1s span {
  min-height: 30px;
  padding: 5px 9px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(190, 207, 230, 0.68);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.67);
  color: #52647a;
  font-size: 10px;
  font-weight: 720;
  line-height: 16px;
  backdrop-filter: blur(8px);
}

.HeroV4_heroAssurances__NYc1s svg {
  color: #0a64f9;
}

@media (max-width: 1120px) {
  .HeroV4_heroOverlay__rBz5F {
    background:
      radial-gradient(
        circle at 12% 15%,
        rgba(255, 255, 255, 0.96),
        transparent 32%
      ),
      linear-gradient(
        90deg,
        #f8faff 0%,
        rgba(248, 250, 255, 0.97) 36%,
        rgba(248, 250, 255, 0.76) 60%,
        rgba(238, 245, 255, 0.2) 100%
      );
  }

  .HeroV4_heroBackdrop__lIUWG {
    object-position: 58% center;
    font-family: 'object-fit: cover; object-position: 58% center;';
  }

  .HeroV4_heroInner__MRZbh {
    width: min(100%, 600px);
  }
}

@media (max-width: 768px) {
  .HeroV4_hero__YXyJQ {
    min-height: auto;
  }

  /* The banner is desktop-only: it is hidden at 768px and below and shows from
     769px up. Hiding the wrapper also parks the crossfade — the element stops
     intersecting, so the rAF loop in Hero.js suspends itself on phones. */
  .HeroV4_heroBackdropStack__7MhA1 {
    display: none;
  }

  /* No banner behind the scrim here, so these stops only tint the hero's own
     background. Kept at the original values so the phone layout is unchanged. */
  .HeroV4_heroOverlay__rBz5F {
    background:
      linear-gradient(
        180deg,
        rgba(248, 250, 255, 0.46) 0%,
        rgba(248, 250, 255, 0.85) 25%,
        rgba(248, 250, 255, 0.96) 60%,
        rgba(240, 247, 255, 0.82) 100%
      ),
      linear-gradient(
        90deg,
        rgba(248, 250, 255, 0.9),
        rgba(248, 250, 255, 0.48)
      );
  }

  .HeroV4_heroGlow__KNEsb {
    top: 35%;
    left: -30%;
    width: 280px;
    height: 280px;
  }

  .HeroV4_heroContent__jbBbz {
    padding: 36px 20px 78px;
    align-items: flex-start;
  }

  .HeroV4_heroInner__MRZbh {
    width: 100%;
  }

  .HeroV4_heroEyebrow__MTsnn {
    min-height: 30px;
    margin-bottom: 15px;
    padding: 5px 9px;
    font-size: 9px;
  }

  .HeroV4_heroTitle__xOrTh {
    max-width: 620px;
    font-size: clamp(36px, 9.2vw, 50px);
    line-height: 1.01;
  }

  .HeroV4_heroSubtitle__8J4fr {
    max-width: 580px;
    margin: 16px 0 20px;
    font-size: 14px;
    line-height: 1.55;
  }

  .HeroV4_searchBox__hRgat {
    padding: 10px;
    border-radius: 18px;
  }

  .HeroV4_searchBoxHeader__7Khi4 {
    padding-bottom: 7px;
  }

  .HeroV4_searchInputWrapper__J9eu1 {
    flex-direction: column;
    gap: 8px;
  }

  .HeroV4_searchInput__kq7kh,
  .HeroV4_searchBtn__7btV2 {
    min-height: 52px;
  }

  .HeroV4_searchInput__kq7kh {
    padding-right: 42px;
    padding-left: 45px;
    font-size: 14px;
  }

  .HeroV4_searchBtn__7btV2 {
    width: 100%;
    min-width: 0;
  }

  .HeroV4_heroActions__ukvXG {
    flex-wrap: wrap;
    gap: 4px 8px;
  }

  .HeroV4_heroAssurances__NYc1s {
    margin-top: 12px;
    gap: 6px;
  }
}

@media (max-width: 480px) {
  .HeroV4_heroContent__jbBbz {
    padding: 32px 16px 76px;
  }

  .HeroV4_heroTitle__xOrTh {
    font-size: clamp(34px, 10vw, 40px);
    letter-spacing: -0.052em;
  }

  .HeroV4_heroSubtitle__8J4fr {
    max-width: 340px;
  }

  .HeroV4_searchBoxHeader__7Khi4 {
    align-items: flex-start;
  }

  .HeroV4_searchCoverage__6MbOd {
    display: none;
  }

  .HeroV4_heroActions__ukvXG {
    min-height: 0;
    margin-top: 8px;
  }

  .HeroV4_heroAssurances__NYc1s {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .HeroV4_heroAssurances__NYc1s span {
    min-width: 0;
    padding: 5px 4px;
    justify-content: center;
    font-size: 10px;
    letter-spacing: -0.02em;
    white-space: nowrap;
  }
}

@media (max-width: 359px) {
  .HeroV4_heroContent__jbBbz {
    padding-right: 12px;
    padding-left: 12px;
  }

  .HeroV4_heroTitle__xOrTh {
    font-size: 32px;
  }

  .HeroV4_heroSubtitle__8J4fr {
    font-size: 13px;
  }

  .HeroV4_signInText__P2Ewl {
    width: 100%;
  }

  .HeroV4_heroAssurances__NYc1s span {
    padding-right: 2px;
    padding-left: 2px;
    gap: 3px;
    font-size: 9.5px;
    letter-spacing: -0.035em;
  }

  .HeroV4_heroAssurances__NYc1s svg {
    width: 12px;
    height: 12px;
  }
}

@media (min-width: 769px) and (max-height: 720px) {
  .HeroV4_hero__YXyJQ {
    min-height: 590px;
  }

  .HeroV4_heroContent__jbBbz {
    padding-top: 42px;
    padding-bottom: 105px;
  }

  .HeroV4_heroEyebrow__MTsnn {
    margin-bottom: 12px;
  }

  .HeroV4_heroTitle__xOrTh {
    font-size: clamp(44px, 5vw, 60px);
  }

  .HeroV4_heroSubtitle__8J4fr {
    margin: 14px 0 18px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .HeroV4_heroInner__MRZbh,
  .HeroV4_heroGlow__KNEsb {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/LandingPage/HeroV4.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;gFAEgF;;AAEhF;EACE;;IAEE,aAAa;IACb,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,kDAAkD;EACpD;AACF;;AAEA;EACE,kBAAkB;EAClB;kEACgE;EAChE,oDAAoD;EACpD,qDAAqD;EACrD,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;uBAEuB;AACvB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB;EAEhB,qCAAqC;EAGrC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,sEAAsE;EACtE,gEAAgE;EAEhE,2BAA2B;AAC7B;;AAEA;;;4EAG4E;AAC5E;EACE,UAAU;EACV,oBAAoB;EACpB;6EAC2E;EAE3E,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV;qEACmE;EACnE,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP;;;;;;;;;;;;;KAaG;EACH,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,8DAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,8DAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;EACzC,oBAAoB;EACpB,qCAAqC;EACrC,8CAA8C;EAC9C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0EAA0E;EAC1E,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC;;sCAEoC;EACpC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB;;;yBAGuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,6DAA6D;EAC7D,8CAA8C;EAC9C,WAAW;EACX,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB;;;qBAGmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,0CAA0C;EAC1C,2CAA2C;EAC3C,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;oBAEkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE;;;;;;;;;;;;OAYG;EACL;;EAEA;IACE,2BAA2B;IAC3B,8DAA8D;EAChE;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;0EAEwE;EACxE;IACE,aAAa;EACf;;EAEA;gFAC8E;EAC9E;IACE;;;;;;;;;;;;OAYG;EACL;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,mCAAmC;IACnC,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kCAAkC;IAClC,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gDAAgD;EAClD;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["@keyframes heroContentReveal {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* The banner crossfade deliberately has no keyframes: it is written frame by\n   frame from Hero.js (see useHeroBannerCrossfade). A CSS animation here would\n   be suppressed by prefers-reduced-motion on the devices this has to work on. */\n\n@keyframes heroGlowDrift {\n  0%,\n  100% {\n    opacity: 0.58;\n    transform: translate3d(0, 0, 0) scale(1);\n  }\n  50% {\n    opacity: 0.82;\n    transform: translate3d(-18px, 10px, 0) scale(1.06);\n  }\n}\n\n.hero {\n  position: relative;\n  /* vh first: browsers without dvh (iOS Safari < 15.4) drop the second line\n     and keep a working height instead of collapsing the banner. */\n  min-height: clamp(660px, calc(100vh - 120px), 840px);\n  min-height: clamp(660px, calc(100dvh - 120px), 840px);\n  display: flex;\n  flex: 1 1 auto;\n  overflow: hidden;\n  box-sizing: border-box;\n  background: #edf4ff;\n}\n\n/* Wrapper carries the shared visual treatment so the crossfading images\n   themselves only ever animate `opacity`. Longhand offsets instead of `inset`\n   for Safari < 14.1. */\n.heroBackdropStack {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  -webkit-filter: saturate(1.03) contrast(1.01);\n  filter: saturate(1.03) contrast(1.01);\n  -webkit-transform: scale(1.015);\n  -ms-transform: scale(1.015);\n  transform: scale(1.015);\n}\n\n.heroBackdrop {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center right;\n  /* Read by the object-fit-images polyfill; harmless everywhere else. */\n  font-family: 'object-fit: cover; object-position: center right;';\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n/* Second banner sits on top and fades in/out over the first one. Hero.js owns\n   the opacity from requestAnimationFrame once both banners have decoded, so a\n   slow or failed download can never crossfade to a blank layer, and no browser\n   motion setting can stop the fade. 0 here is the resting/fallback state. */\n.heroBackdropAlt {\n  opacity: 0;\n  will-change: opacity;\n  /* A global `transition: all` rule is in scope here; left alone it re-times\n     every frame we write. The rAF timeline is the only thing driving this. */\n  -webkit-transition: none;\n  transition: none;\n}\n\n.heroOverlay {\n  position: absolute;\n  z-index: 1;\n  /* Longhand offsets instead of `inset` for Safari < 14.1, which would\n     otherwise drop the shorthand and leave the scrim unpositioned. */\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background:\n    radial-gradient(\n      circle at 12% 17%,\n      rgba(255, 255, 255, 0.96) 0,\n      rgba(255, 255, 255, 0) 31%\n    ),\n    linear-gradient(\n      90deg,\n      #f8faff 0%,\n      rgba(248, 250, 255, 0.98) 24%,\n      rgba(248, 250, 255, 0.88) 42%,\n      rgba(238, 245, 255, 0.36) 65%,\n      rgba(222, 235, 255, 0.05) 100%\n    );\n  pointer-events: none;\n}\n\n.heroGlow {\n  position: absolute;\n  z-index: 2;\n  top: 12%;\n  left: 34%;\n  width: 330px;\n  height: 330px;\n  border-radius: 50%;\n  background: rgba(54, 135, 255, 0.18);\n  filter: blur(90px);\n  animation: heroGlowDrift 9s ease-in-out infinite;\n  pointer-events: none;\n}\n\n.heroContent {\n  position: relative;\n  z-index: 15;\n  width: 100%;\n  max-width: 1344px;\n  margin: 0 auto;\n  padding: clamp(64px, 8vh, 92px) 32px 120px;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.heroInner {\n  width: min(100%, 660px);\n  animation: heroContentReveal 600ms ease-out both;\n}\n\n.heroEyebrow {\n  width: fit-content;\n  min-height: 32px;\n  margin-bottom: 20px;\n  padding: 6px 11px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  border: 1px solid rgba(10, 100, 249, 0.2);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.72);\n  box-shadow: 0 7px 22px rgba(32, 83, 150, 0.08);\n  color: #075bd7;\n  font-size: 11px;\n  font-weight: 850;\n  letter-spacing: 0.09em;\n  line-height: 18px;\n  text-transform: uppercase;\n  backdrop-filter: blur(12px);\n}\n\n.heroTitle {\n  max-width: 650px;\n  margin: 0;\n  color: #071b35;\n  font-size: clamp(48px, 5.05vw, 72px);\n  font-weight: 880;\n  letter-spacing: -0.058em;\n  line-height: 0.99;\n  text-wrap: balance;\n}\n\n.heroTitleHighlight {\n  display: inline;\n  background: linear-gradient(110deg, #075ee8 4%, #0a74ff 56%, #0957d7 100%);\n  background-clip: text;\n  color: transparent;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.heroSubtitle {\n  max-width: 570px;\n  margin: 22px 0 28px;\n  color: #52647c;\n  font-size: clamp(16px, 1.3vw, 18px);\n  font-weight: 560;\n  line-height: 1.65;\n  text-wrap: pretty;\n}\n\n.searchBox {\n  position: relative;\n  z-index: 2;\n  width: min(100%, 650px);\n  margin: 0;\n  padding: 12px;\n  border: 1px solid rgba(194, 211, 234, 0.86);\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow:\n    0 24px 70px rgba(21, 61, 119, 0.15),\n    0 3px 10px rgba(21, 61, 119, 0.05);\n  box-sizing: border-box;\n  backdrop-filter: blur(18px);\n}\n\n.searchBoxHeader {\n  min-height: 29px;\n  padding: 0 5px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.searchLabel {\n  color: #182f4e;\n  font-size: 12px;\n  font-weight: 820;\n  letter-spacing: -0.01em;\n  line-height: 18px;\n}\n\n.searchCoverage {\n  color: #74849a;\n  font-size: 10px;\n  font-weight: 720;\n  letter-spacing: 0.04em;\n  line-height: 16px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.searchInputWrapper {\n  display: flex;\n  align-items: stretch;\n  gap: 9px;\n}\n\n.inputWrap {\n  position: relative;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.inputIcon {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 17px;\n  color: #0a64f9;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.searchInput {\n  width: 100%;\n  min-height: 58px;\n  padding: 0 44px 0 49px;\n  border: 1px solid #dde8f6;\n  border-radius: 13px;\n  outline: none;\n  background: #f3f7fd;\n  color: #102741;\n  font-family: 'Manrope', 'Inter', system-ui, sans-serif;\n  font-size: 15px;\n  font-weight: 620;\n  box-sizing: border-box;\n  transition:\n    border-color 160ms ease,\n    background 160ms ease,\n    box-shadow 160ms ease;\n}\n\n.searchInput::placeholder {\n  color: #7d899a;\n  font-weight: 520;\n}\n\n.searchInput:hover {\n  border-color: #c6d8ee;\n  background: #f8fbff;\n}\n\n.searchInput:focus {\n  border-color: #6da5f8;\n  background: #fff;\n  box-shadow: 0 0 0 4px rgba(10, 100, 249, 0.11);\n}\n\n.loader {\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  display: grid;\n  place-items: center;\n  color: #0a64f9;\n  transform: translateY(-50%);\n}\n\n.searchBtn {\n  min-width: 170px;\n  min-height: 58px;\n  padding: 0 23px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  flex: 0 0 auto;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 13px;\n  background: linear-gradient(135deg, #0b6bff 0%, #084ecf 100%);\n  box-shadow: 0 11px 24px rgba(8, 82, 207, 0.24);\n  color: #fff;\n  font-family: 'Manrope', 'Inter', system-ui, sans-serif;\n  font-size: 14px;\n  font-weight: 820;\n  line-height: 20px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    box-shadow 160ms ease,\n    transform 160ms ease,\n    filter 160ms ease;\n}\n\n.searchBtn:hover:not(:disabled) {\n  filter: brightness(1.06);\n  box-shadow: 0 14px 30px rgba(8, 82, 207, 0.32);\n  transform: translateY(-1px);\n}\n\n.searchBtn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.searchBtn:disabled {\n  opacity: 0.68;\n  cursor: wait;\n}\n\n.searchBtn:focus-visible,\n.signInLink:focus-visible {\n  outline: 3px solid rgba(10, 100, 249, 0.24);\n  outline-offset: 3px;\n}\n\n.dropdown {\n  position: absolute;\n  z-index: 20;\n  top: calc(100% + 6px);\n  right: 0;\n  left: 0;\n  width: 100%;\n  max-height: min(260px, calc(100vh - 90px));\n  max-height: min(260px, calc(100dvh - 90px));\n  margin: 0;\n  padding: 6px;\n  overflow: hidden auto;\n  border: 1px solid #dce7f4;\n  border-radius: 15px;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 22px 52px rgba(13, 40, 77, 0.2);\n  list-style: none;\n  backdrop-filter: blur(16px);\n}\n\n.dropdownItem {\n  min-height: 54px;\n  padding: 9px 10px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  border-radius: 10px;\n  color: #34465e;\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background 140ms ease,\n    color 140ms ease;\n}\n\n.dropdownItem:hover,\n.dropdownItemActive,\n.dropdownItem[aria-selected='true'] {\n  background: #edf5ff;\n  color: #0a55c7;\n}\n\n.dropdownItemIconWrapper {\n  width: 30px;\n  height: 30px;\n  margin-top: 1px;\n  display: grid;\n  place-items: center;\n  flex: 0 0 30px;\n  border-radius: 9px;\n  background: #e5f0ff;\n  color: #0a64f9;\n}\n\n.dropdownItemText {\n  min-width: 0;\n  padding-top: 1px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.dropdownItemPrimary,\n.dropdownItemSecondary {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dropdownItemPrimary {\n  color: #112841;\n  font-size: 13px;\n  font-weight: 760;\n  line-height: 18px;\n}\n\n.dropdownItemSecondary {\n  color: #6d7d91;\n  font-size: 11px;\n  font-weight: 540;\n  line-height: 16px;\n}\n\n.error {\n  margin: 9px 4px 0;\n  padding: 8px 10px;\n  border: 1px solid #ffd3d8;\n  border-radius: 9px;\n  background: #fff5f6;\n  color: #b42335;\n  font-size: 11px;\n  font-weight: 690;\n  line-height: 16px;\n  text-align: left;\n}\n\n.heroActions {\n  min-height: 32px;\n  margin-top: 10px;\n  padding: 0 4px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.signInText {\n  min-height: 26px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #65748a;\n  font-size: 11px;\n  font-weight: 640;\n  line-height: 17px;\n}\n\n.signInLink {\n  margin: 0 -2px 0 1px;\n  padding: 3px 2px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: #075bdb;\n  font: inherit;\n  font-weight: 820;\n  cursor: pointer;\n}\n\n.signInLink:hover {\n  color: #0647aa;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.heroAssurances {\n  margin-top: 15px;\n  display: flex;\n  align-items: center;\n  flex-flow: row wrap;\n  gap: 8px;\n}\n\n.heroAssurances span {\n  min-height: 30px;\n  padding: 5px 9px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid rgba(190, 207, 230, 0.68);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.67);\n  color: #52647a;\n  font-size: 10px;\n  font-weight: 720;\n  line-height: 16px;\n  backdrop-filter: blur(8px);\n}\n\n.heroAssurances svg {\n  color: #0a64f9;\n}\n\n@media (max-width: 1120px) {\n  .heroOverlay {\n    background:\n      radial-gradient(\n        circle at 12% 15%,\n        rgba(255, 255, 255, 0.96),\n        transparent 32%\n      ),\n      linear-gradient(\n        90deg,\n        #f8faff 0%,\n        rgba(248, 250, 255, 0.97) 36%,\n        rgba(248, 250, 255, 0.76) 60%,\n        rgba(238, 245, 255, 0.2) 100%\n      );\n  }\n\n  .heroBackdrop {\n    object-position: 58% center;\n    font-family: 'object-fit: cover; object-position: 58% center;';\n  }\n\n  .heroInner {\n    width: min(100%, 600px);\n  }\n}\n\n@media (max-width: 768px) {\n  .hero {\n    min-height: auto;\n  }\n\n  /* The banner is desktop-only: it is hidden at 768px and below and shows from\n     769px up. Hiding the wrapper also parks the crossfade — the element stops\n     intersecting, so the rAF loop in Hero.js suspends itself on phones. */\n  .heroBackdropStack {\n    display: none;\n  }\n\n  /* No banner behind the scrim here, so these stops only tint the hero's own\n     background. Kept at the original values so the phone layout is unchanged. */\n  .heroOverlay {\n    background:\n      linear-gradient(\n        180deg,\n        rgba(248, 250, 255, 0.46) 0%,\n        rgba(248, 250, 255, 0.85) 25%,\n        rgba(248, 250, 255, 0.96) 60%,\n        rgba(240, 247, 255, 0.82) 100%\n      ),\n      linear-gradient(\n        90deg,\n        rgba(248, 250, 255, 0.9),\n        rgba(248, 250, 255, 0.48)\n      );\n  }\n\n  .heroGlow {\n    top: 35%;\n    left: -30%;\n    width: 280px;\n    height: 280px;\n  }\n\n  .heroContent {\n    padding: 36px 20px 78px;\n    align-items: flex-start;\n  }\n\n  .heroInner {\n    width: 100%;\n  }\n\n  .heroEyebrow {\n    min-height: 30px;\n    margin-bottom: 15px;\n    padding: 5px 9px;\n    font-size: 9px;\n  }\n\n  .heroTitle {\n    max-width: 620px;\n    font-size: clamp(36px, 9.2vw, 50px);\n    line-height: 1.01;\n  }\n\n  .heroSubtitle {\n    max-width: 580px;\n    margin: 16px 0 20px;\n    font-size: 14px;\n    line-height: 1.55;\n  }\n\n  .searchBox {\n    padding: 10px;\n    border-radius: 18px;\n  }\n\n  .searchBoxHeader {\n    padding-bottom: 7px;\n  }\n\n  .searchInputWrapper {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .searchInput,\n  .searchBtn {\n    min-height: 52px;\n  }\n\n  .searchInput {\n    padding-right: 42px;\n    padding-left: 45px;\n    font-size: 14px;\n  }\n\n  .searchBtn {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .heroActions {\n    flex-wrap: wrap;\n    gap: 4px 8px;\n  }\n\n  .heroAssurances {\n    margin-top: 12px;\n    gap: 6px;\n  }\n}\n\n@media (max-width: 480px) {\n  .heroContent {\n    padding: 32px 16px 76px;\n  }\n\n  .heroTitle {\n    font-size: clamp(34px, 10vw, 40px);\n    letter-spacing: -0.052em;\n  }\n\n  .heroSubtitle {\n    max-width: 340px;\n  }\n\n  .searchBoxHeader {\n    align-items: flex-start;\n  }\n\n  .searchCoverage {\n    display: none;\n  }\n\n  .heroActions {\n    min-height: 0;\n    margin-top: 8px;\n  }\n\n  .heroAssurances {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .heroAssurances span {\n    min-width: 0;\n    padding: 5px 4px;\n    justify-content: center;\n    font-size: 10px;\n    letter-spacing: -0.02em;\n    white-space: nowrap;\n  }\n}\n\n@media (max-width: 359px) {\n  .heroContent {\n    padding-right: 12px;\n    padding-left: 12px;\n  }\n\n  .heroTitle {\n    font-size: 32px;\n  }\n\n  .heroSubtitle {\n    font-size: 13px;\n  }\n\n  .signInText {\n    width: 100%;\n  }\n\n  .heroAssurances span {\n    padding-right: 2px;\n    padding-left: 2px;\n    gap: 3px;\n    font-size: 9.5px;\n    letter-spacing: -0.035em;\n  }\n\n  .heroAssurances svg {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n@media (min-width: 769px) and (max-height: 720px) {\n  .hero {\n    min-height: 590px;\n  }\n\n  .heroContent {\n    padding-top: 42px;\n    padding-bottom: 105px;\n  }\n\n  .heroEyebrow {\n    margin-bottom: 12px;\n  }\n\n  .heroTitle {\n    font-size: clamp(44px, 5vw, 60px);\n  }\n\n  .heroSubtitle {\n    margin: 14px 0 18px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .heroInner,\n  .heroGlow {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `HeroV4_hero__YXyJQ`,
	"heroBackdropStack": `HeroV4_heroBackdropStack__7MhA1`,
	"heroBackdrop": `HeroV4_heroBackdrop__lIUWG`,
	"heroBackdropAlt": `HeroV4_heroBackdropAlt__3LQOy`,
	"heroOverlay": `HeroV4_heroOverlay__rBz5F`,
	"heroGlow": `HeroV4_heroGlow__KNEsb`,
	"heroGlowDrift": `HeroV4_heroGlowDrift__77qDm`,
	"heroContent": `HeroV4_heroContent__jbBbz`,
	"heroInner": `HeroV4_heroInner__MRZbh`,
	"heroContentReveal": `HeroV4_heroContentReveal__cUbIX`,
	"heroEyebrow": `HeroV4_heroEyebrow__MTsnn`,
	"heroTitle": `HeroV4_heroTitle__xOrTh`,
	"heroTitleHighlight": `HeroV4_heroTitleHighlight__xHXks`,
	"heroSubtitle": `HeroV4_heroSubtitle__8J4fr`,
	"searchBox": `HeroV4_searchBox__hRgat`,
	"searchBoxHeader": `HeroV4_searchBoxHeader__7Khi4`,
	"searchLabel": `HeroV4_searchLabel__wdmLP`,
	"searchCoverage": `HeroV4_searchCoverage__6MbOd`,
	"searchInputWrapper": `HeroV4_searchInputWrapper__J9eu1`,
	"inputWrap": `HeroV4_inputWrap__GsJ2D`,
	"inputIcon": `HeroV4_inputIcon__rszDu`,
	"searchInput": `HeroV4_searchInput__kq7kh`,
	"loader": `HeroV4_loader__aSiAm`,
	"searchBtn": `HeroV4_searchBtn__7btV2`,
	"signInLink": `HeroV4_signInLink__LLQ2+`,
	"dropdown": `HeroV4_dropdown__BTdEQ`,
	"dropdownItem": `HeroV4_dropdownItem__tWDSK`,
	"dropdownItemActive": `HeroV4_dropdownItemActive__QKtqz`,
	"dropdownItemIconWrapper": `HeroV4_dropdownItemIconWrapper__3kdgJ`,
	"dropdownItemText": `HeroV4_dropdownItemText__qRdg7`,
	"dropdownItemPrimary": `HeroV4_dropdownItemPrimary__DW8Qn`,
	"dropdownItemSecondary": `HeroV4_dropdownItemSecondary__lko4R`,
	"error": `HeroV4_error__g1aoX`,
	"heroActions": `HeroV4_heroActions__ukvXG`,
	"signInText": `HeroV4_signInText__P2Ewl`,
	"heroAssurances": `HeroV4_heroAssurances__NYc1s`
};
export default ___CSS_LOADER_EXPORT___;
